import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';
import { FileDropZoneTileComponent } from '@lite-workspace/shared/helm-ui/file-drop-zone';
import { HlmButton } from '@lite-workspace/shared/helm-ui/button';
import { DialogSheetComponent } from '@lite-workspace/shared/helm-ui/dialog';
import { FilePickerService } from '@lite-workspace/uploader-core';

/**
 * Что уносит закрытие: только файлы. Метки волны здесь больше нет — автоимена всегда включены под
 * капотом (nameSource дефолтится в UploadIntakeFlagService), переключатель из диалога убран.
 */
export interface UploadPhotosDialogResult {
  readonly files: File[];
}

@Component({
  selector: 'app-upload-photos-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FileDropZoneTileComponent, HlmButton, DialogSheetComponent],
  host: {
    class:
      'block dlg-phone:contents dlg-desktop:w-[var(--dlg-w-admin-contact)] dlg-desktop:rounded-[var(--r-xl)] ' +
      'dlg-desktop:border dlg-desktop:border-line2 dlg-desktop:bg-panel dlg-desktop:p-6 ' +
      'dlg-desktop:shadow-[var(--shadow-4)]',
  },
  template: `
    <hlm-dialog-sheet>
      <ng-template>
        <hlm-file-drop-zone-tile
          icon="download"
          label="Перетащите или выберите фото"
          hint="Имя файла ретуши должно совпадать с исходным фото в проекте"
          accept="image/*"
          [multiple]="true"
          (filesDropped)="pick($event)"
        />

        <div class="mt-5 flex justify-end gap-2">
          <button hlmBtn type="button" variant="outline" (click)="cancel()">Отмена</button>
          <button hlmBtn type="button" variant="default" (click)="openPicker()">Выбрать файлы</button>
        </div>
      </ng-template>
    </hlm-dialog-sheet>
  `,
})
export class UploadPhotosDialogComponent {
  private readonly dialogRef = inject(BrnDialogRef);
  private readonly filePicker = inject(FilePickerService);

  protected openPicker(): void {
    void this.filePicker
      .open({ acceptedTypes: 'image/*' })
      .then(files => this.pick(files.filter(file => file.type.startsWith('image/'))));
  }

  /** Закрытие мгновенное: «плитка → системный выбор → загрузка», без экранов-вопросов по дороге. */
  protected pick(files: File[]): void {
    if (files.length === 0) return;
    this.dialogRef.close({ files } satisfies UploadPhotosDialogResult);
  }

  protected cancel(): void {
    this.dialogRef.close(undefined);
  }
}
